import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.359 13.5001C17.8425 13.5002 18.2866 13.6735 18.6334 13.9615C18.9058 13.9674 19.1736 14.0838 19.365 14.3025C19.7009 14.6863 19.6855 15.2449 19.3691 15.6119L19.3699 15.6176C19.4341 16.5486 18.7647 17.3485 17.8693 17.4788L18.0003 17.9996V18.5433C18.2913 18.6463 18.4998 18.9234 18.5 19.2496V19.5003H17.0001V19.2496C17.0003 18.9611 17.1632 18.7109 17.4022 18.5856L17.4998 17.9996L17.4266 17.4886C17.2546 17.4703 17.0899 17.4267 16.9367 17.3616C16.7643 17.3182 16.5946 17.2439 16.4435 17.1403L15.9275 16.7854C15.4338 16.4467 15.3461 15.7533 15.7404 15.3027C15.8245 15.2066 15.9234 15.13 16.0309 15.074C16.1211 14.2345 16.4356 13.5002 17.263 13.5001H17.359Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.63342 1.89691C7.83137 1.6832 8.16963 1.68305 8.36747 1.89691L11.4998 5.28314V3.99977H13.5001V7.44623L14.7249 8.7711C14.8395 8.89496 14.9194 9.0449 14.9601 9.20567C14.9861 9.2954 14.9999 9.38907 15 9.48399V19.4994H14.6378C14.4808 19.7713 14.2006 19.9622 13.8737 19.9951L13.7727 19.9999H9.50028V15.4996C9.50007 14.6714 8.82793 13.9998 7.99963 13.9998C7.17151 14 6.50001 14.6715 6.4998 15.4996V19.9999H2.22734L2.12724 19.9951C1.79983 19.9624 1.51861 19.7716 1.36145 19.4994H1.00012V9.48399C1.00016 9.38596 1.01396 9.28911 1.04163 9.19671C1.07486 9.07012 1.13272 8.95029 1.21252 8.84515L1.27519 8.7711L7.63342 1.89691ZM7.99963 7.99961C7.17137 7.99981 6.4998 8.67196 6.4998 9.50026C6.49996 10.3284 7.17148 10.9999 7.99963 11.0001C8.82796 11.0001 9.50012 10.3285 9.50028 9.50026C9.50028 8.67183 8.82806 7.99961 7.99963 7.99961Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 20C0 19.4477 0.447715 19 1 19H19C19.5523 19 20 19.4477 20 20H0Z",
			fill: "currentColor"
		})
	]
});
export default SvgHouseFill;
